import styled from 'styled-components/macro';

export const EditStepWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
`;
